$(document).ready(function() {
  console.log('announcement');
  console.log($('.announcement').length);
  if ($('.announcement').length > 0) {
    console.log('announcement');
    $('body').addClass('has-announcement');
  }
  $(document).on('click', '.copy-btn', function () {
        const textToCopy = $(this).siblings('.text-to-copy').text();
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                alert('Code copied to clipboard: ' + textToCopy);
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    });
  if($('.announcement').length){
    $('.announcement').parent().addClass('announcement_wrapper');
    $('.site-header').addClass('hasAnnouncement').css('top',$('.announcement').outerHeight(true));
    //$('#NavDrawer').css('top',$('.announcement').outerHeight(true));
    $('#PageContainer').addClass('hasAnnouncementBar');

     window.addEventListener('scroll', function () {
      const bar = document.querySelector('.announcement');
      if (window.scrollY > 0) {
        bar.classList.add('hidden');
        $('.site-header').removeClass('hasAnnouncement').css('top',0);
      //  $('#NavDrawer').css('top',0);
      } else {
        bar.classList.remove('hidden');
        $('.site-header').addClass('hasAnnouncement').css('top',$('.announcement').outerHeight(true));
       // $('#NavDrawer').css('top',$('.announcement').outerHeight(true));
      }
    });
  }
  setTimeout(function() {
         console.log('doc ready');
  console.log($('div[option-name="Style"]').length);
  $('div[option-name="Style"] ul li').on('click',function() {
    console.log('style select');
    setTimeout(function() {
        // Your jQuery code here
     $('div[option-name="Color"] ul li span').click()

    }, 500);
  });
    }, 5000);



    $('.clear-cart').on('click', function() {

       $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function() {
                // Successfully cleared the cart, update cart UI here
                $('.cart-items').empty(); // Clear items in the cart UI
                $('.cart-total').text('0.00'); // Update total price if applicable
            },
            error: function() {
                console.error('Failed to clear the cart.');
            }
        });
    });
});
$(document).ready(function() {
  // Check if the popup has been shown in the last 14 days
  // const lastPopupShown = localStorage.getItem('newsletterPopupShown');
  // const twoWeeks = 14 * 24 * 60 * 60 * 1000; // Two weeks in milliseconds
  // const now = new Date().getTime();
  // console.log('popup');
  // If popup has never been shown or it was shown more than 14 days ago
  // if (!lastPopupShown || now - lastPopupShown > twoWeeks) {
  //   console.log('popup in');
  //   // Show the popup after page load
  //   setTimeout(function() {
  //     $.ajax({
  //       url: 'https://sixzerorender.onrender.com/check-customer-orders',
  //       type: 'POST',
  //       contentType: 'application/json',  // Set content type to JSON
  //       data: JSON.stringify({ email: "test@test.com", store: "CA" }),  // Convert data to JSON string
  //       success: function (response) {},
  //     });
  //     $('#newsletter-popup').css('visibility','visible');
  //     $('#newsletter-popup').fadeIn();
  //   }, 2000); // 2-second delay

  //   // Set the current time as the last time the popup was shown
  //   localStorage.setItem('newsletterPopupShown', now);
  // }

  // Close popup when "X" is clicked
  $('.close-popup').click(function() {
    $('#newsletter-popup').fadeOut();
    //$('#products-popup').fadeOut();
    $('#products-popup').css('visibility','hidden');
    return false;
  });

  // Optional: Close the popup when the user clicks outside the content area
  $(window).click(function(event) {
    if ($(event.target).is('#newsletter-popup')) {
      $('#newsletter-popup').fadeOut();
    }
  });

});
$(document).ready(function () {
  //$('.popup-overlay').css('visibility','visible');
  //$('.popup-overlay').hide();
  $('.popup-footer .btn.checkout').click(function(){
    $('.btn.cart__checkout').click();
  });
  setTimeout(function () {
          //$('.popup-overlay').css('visibility','visible');
           //$('.popup-overlay').hide();
        }, 100);
  const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('popup') === 'signup') {
      console.log('popup - signup');
$.ajax({
  url: 'https://sixzerorender.onrender.com/check-customer-orders',
  type: 'POST',
  contentType: 'application/json',  // Set content type to JSON
  data: JSON.stringify({ email: "test@test.com", store: "CA" }),  // Convert data to JSON string
  success: function (response) {},
});

      $('#newsletter-popup').css('visibility','visible');
        $('#newsletter-popup').fadeIn();
      //$('#products-popup').fadeIn();
    }

  $('#newsletter-form').submit(function (e) {
    e.preventDefault();
   $('#newsletter-form .form-items').hide();
     $('#coupon-message').text("Sending...");
   const email = $('#email-input').val();

$.ajax({
  url: 'https://sixzerorender.onrender.com/check-customer-orders',
  type: 'POST',
  contentType: 'application/json',  // Set content type to JSON
  data: JSON.stringify({ email: email, store: "CA" }),  // Convert data to JSON string
  success: function (response) {
    $('#newsletter-form .form-items').hide();
    if (response.isNewCustomer) {
      //$('#coupon-message').html("Use code <b class='text-to-copy'>WELC12</b> at checkout to receive 12% off.<br/><button class='copy-btn'>Click to Copy Code</button>");
       $('#coupon-message').html("Welcome to the Six Zero family")
    } else {
    $('#coupon-message').html(`
    <p>
        It looks like you've purchased from Six Zero already. Here's a discount code for 15% OFF apparel<br/>
        Code: <span class='text-to-copy'>APP15</span><label>
            <br/>
            <button class='copy-btn'>Click to Copy Code</button>
        </label>
    </p>
`);

    }
  },
  error: function () {
    $('#coupon-message').text("An error occurred. Please try again.");
  },
});

  });
});

function removeFromCart(event, itemId) {
     event.preventDefault();  // Prevent form submission or default action
     event.stopPropagation(); // Stop event from bubbling up
     event.stopImmediatePropagation(); // Stop other event listeners on the same element
     console.log(itemId);
     console.log('removeFromCart triggered');
      //return false;
     fetch('/cart/change.js', {
         method: 'POST',
         headers: {
             'Content-Type': 'application/json'
         },
         body: JSON.stringify({
             id: itemId,
             quantity: 0
         })
     })
     .then(response => response.json())
     .then(cart => {
         updateCartUI(cart,itemId);
     })
     .catch(error => console.error("Error:", error));

     return false; // Prevent further handling
 }

// Function to update cart UI dynamically
function updateCartUI(cart, itemId) {
    // Remove the item from the cart UI
    let itemElement = document.querySelector(`.cart_item_${itemId}`);
    if (itemElement) {
        itemElement.remove();
    }
    console.log(cart);
    // Update cart total price
    let cartTotalElement = document.querySelector("div[data-subtotal]");
    if (cartTotalElement) {
        let cartTotal = cart.items_subtotal_price / 100; // Convert cents to dollars
        cartTotalElement.textContent = `$${cartTotal.toFixed(2)}`;
    }

    // Hide cart if empty
    if (cart.item_count === 0) {
        let cartContainer = document.querySelector("#CartDrawer .drawer__scrollable");
        if (cartContainer) {
            //cartContainer.innerHTML = "Your cart is empty.";
        }
      //drawer__footer
      let cartFooter = document.querySelector("#CartDrawer .drawer__footer");
        if (cartContainer) {
            //cartFooter.remove();
            $('.cart-link__bubble').removeClass('cart-link__bubble--visible');
        }
    }
}

$(document).ready(function() {
  setTimeout(function () {
  if ($(window).width() <= 767) {

    $('.grid').each(function() {
      var $grid = $(this);
      var $container = $grid.find('> .product-grid-container'); // Only direct children
      var $items = $container.find('.grid__item');
      console.log($container.length);
      if ($items.length === 0) return; // Skip if no items

      $container.remove(); // Remove original container

      for (var i = 0; i < $items.length; i += 2) {
        var $newContainer = $('<div class="product-grid-container"></div>');
        $newContainer.append($items.slice(i, i + 2));
        $grid.append($newContainer);
      }
    });
  }
      $('.grid-overflow-wrapper .grid, .grid .product-grid-container').each(function() {
        var $grid = $(this);
        var addClass = false;

        $grid.find('ul.swatch-view').each(function() {
          if ($(this).find('li').length > 2) {
            addClass = true;
            return false; // Exit loop early since we found one
          }
        });

        if (addClass) {
          $grid.find('ul.swatch-view').addClass('extra-height');
        }
      });
  }, 2000);

});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header-item [data-disclosure-form]').forEach(function (el) {
    new theme.Disclosure(el);
  });
});
document.querySelectorAll(' [data-disclosure-option]').forEach(option => {
  option.addEventListener('click', function(e) {

    const redirectUrl = e.currentTarget.getAttribute('data-redirect-url');
    if (redirectUrl) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Stop other handlers (like Shopify’s Disclosure logic)
      console.log(redirectUrl);
      window.location.href = redirectUrl;
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  // Check if the fieldset with name="Texture" exists
  const textureFieldset = document.querySelector('fieldset.variant-input-wrap[name="T"]');
  if (textureFieldset) {
    // Hide the parent div
    const parentDiv = textureFieldset.closest('div');
    if (parentDiv) {
      parentDiv.style.display = "none";
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
    // Only run if on sixzeropickleball.com domain

    if (window.location.hostname == "www.sixzeropickleball.com" &&
        window.location.pathname.endsWith("/apps/product-registration")) {

         fetch("https://ipapi.co/json/")
                  .then(res => res.json())
                  .then(data => {
                    console.log("Detected country:", data.country);

                    const NORTH_AMERICA_COUNTRIES = [
                      "US", "MX", "BM", "GL", "PM",
                      "GT", "BZ", "SV", "HN", "NI", "CR", "PA",
                      "BS", "CU", "JM", "HT", "DO",
                      "KN", "LC", "VC", "BB", "GD", "AG", "DM", "TT"
                    ];

                    const params = new URLSearchParams(window.location.search);
                    const id = params.get("ID");

                    if (!id) return;

                    // 🇨🇦 Canada → CA store
                    if (data.country === "CA") {
                      window.location.href =
                        `https://sixzerocanada.com/apps/product-registration?ID=${encodeURIComponent(id)}`;
                    }

                    // 🌎 North America (except CA) → US store
                    else if (NORTH_AMERICA_COUNTRIES.includes(data.country)) {
                      // window.location.href =
                      //   `https://us.sixzeropickleball.com/apps/product-registration?ID=${encodeURIComponent(id)}`;
                    }
                  })
                  .catch(err => console.error("Geo-location error:", err));

        }
        else {
        // fetch('https://ipapi.co/json/') // You can use another geo-location API if needed
        // .then(response => response.json())
        // .then(data => {

        //     if (data.country === "CA") {
        //          console.log('Canada user');
        //           eraseCookie('localization');
        //           eraseCookie('mdApp_countryCodeDomain');
        //           console.log(window.location.pathname);
        //       let redirectUrl = "https://sixzerocanada.com/"+window.location.pathname;


        //         const urlParams = new URLSearchParams(window.location.search);
        //         const scaRef = urlParams.get('sca_ref');

        //         if (scaRef) {
        //               redirectUrl += `&sca_ref=${encodeURIComponent(scaRef)}`;

        //         }

        //         window.location.href = redirectUrl;


        //     }
        // })
        // .catch(error => console.error('Geo-location error:', error));
        const ua = navigator.userAgent.toLowerCase();

const botPatterns = [
  "googlebot",
  "google-inspectiontool",
  "googleother",
  "adsbot-google",
  "bingbot",
  "bingpreview",
  "duckduckbot",
  "yandexbot",
  "baiduspider",
  "slurp"
];

const isBot = botPatterns.some(bot => ua.includes(bot));
console.log('check bot');
console.log(ua);

if (isBot) {
  console.log("Bot detected — skipping geo redirect");
  return;
}

        const STORES = {
        US: "us.sixzeropickleball.com",
        CA: "sixzerocanada.com",
        MAIN: "sixzeropickleball.com"
        };

      const NORTH_AMERICA_COUNTRIES = [
        "US", "MX", "BM", "GL", "PM",
        "GT", "BZ", "SV", "HN", "NI", "CR", "PA",
        "BS", "CU", "JM", "HT", "DO",
        "KN", "LC", "VC", "BB", "GD", "AG", "DM", "TT"
      ];

      const params = new URLSearchParams(window.location.search);

      // 🔕 Bypass redirect if param exists
      if (
        params.get("geo_redirect") === "off" ||
        params.get("geo_bypass") === "true"
      ) {
        sessionStorage.setItem('geo_redirect', "off");

      }
      if (
        params.get("geo_redirect") === "on" ||
        params.get("geo_bypass") === "false"
      ) {
        sessionStorage.setItem('geo_redirect', "on");

      }
      if (sessionStorage.getItem('geo_redirect')=="off") return;

      const currentHost = window.location.hostname;
      const currentPath = window.location.pathname;
      const currentQuery = window.location.search;

      // Prevent redirect loops
      const sessionKey = "geo_redirect_done";
      //if (sessionStorage.getItem(sessionKey)) return;
      console.log('geo redirect');
      fetch("https://ipapi.co/json/")
        .then(res => res.json())
        .then(data => {
          const country = data.country;

          let targetDomain = null;

          // 🇨🇦 Canada → CA store
          if (country === "CA") {
            if (currentHost !== STORES.CA) {
              targetDomain = STORES.CA;
            }
          }

          // 🌎 North America (except CA) → US store
          else if (NORTH_AMERICA_COUNTRIES.includes(country)) {
            if (currentHost !== STORES.US) {
              //targetDomain = STORES.US;
            }
          }
            // 🌍 Outside North America
          else {
            if (
              currentHost === STORES.US ||
              currentHost === STORES.CA
            ) {
              targetDomain = STORES.MAIN;
            }
          }

          if (targetDomain) {
            sessionStorage.setItem(sessionKey, "true");

            eraseCookie("localization");
            eraseCookie("mdApp_countryCodeDomain");

            window.location.href =
              `https://${targetDomain}${currentPath}${currentQuery}`;
          }
        })
        .catch(err => console.error("Geo-location error:", err));

      }
           function eraseCookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + location.hostname + ';';
    }
});

/* =================================================================
 SIZE GUIDE — For Image Size Guide
 ================================================================= */
(function () {
   const sizeGuideEl = document.querySelector('.grid-product__sizeguide');
   if (!sizeGuideEl) return;
   const imageUrl = window.__sizeGuideImageUrl || '';
   // Create modal elements
   const overlay = document.createElement('div');
   overlay.id = 'size-guide-overlay';
   Object.assign(overlay.style, {
     display: 'none',
     position: 'fixed',
     inset: '0',
     background: 'rgba(0,0,0,0.6)',
     zIndex: '9999',
     alignItems: 'center',
     justifyContent: 'center',
   });
   const modal = document.createElement('div');
   Object.assign(modal.style, {
     position: 'relative',
     background: '#fff',
     borderRadius: '8px',
     padding: '16px',
     maxWidth: '90vw',
     maxHeight: '90vh',
     overflow: 'auto',
     boxSizing: 'border-box',
     display: 'flex',
     alignItems: 'center',
     justifyContent: 'center',
   });
   const closeBtn = document.createElement('button');
   closeBtn.innerHTML = '&times;';
   Object.assign(closeBtn.style, {
     position: 'absolute',
     top: '8px',
     right: '12px',
     background: 'none',
     border: 'none',
     fontSize: '24px',
     cursor: 'pointer',
     lineHeight: '1',
     color: '#333',
   });
   const img = document.createElement('img');
   img.src = imageUrl;
   img.alt = 'Size Guide';
   Object.assign(img.style, {
     display: 'block',
     maxWidth: '100%',
     maxHeight: 'calc(90vh - 64px)',
     width: 'auto',
     height: 'auto',
     margin: 'auto',
   });
   img.onload = function () {
     modal.style.width = img.naturalWidth + 32 + 'px';
   };
   modal.appendChild(closeBtn);
   modal.appendChild(img);
   overlay.appendChild(modal);
   document.body.appendChild(overlay);
   function openModal() {
     overlay.style.display = 'flex';
     document.body.style.overflow = 'hidden';
   }
   function closeModal() {
     overlay.style.display = 'none';
     document.body.style.overflow = '';
   }
   sizeGuideEl.style.cursor = 'pointer';
   sizeGuideEl.addEventListener('click', openModal);
   closeBtn.addEventListener('click', closeModal);
   overlay.addEventListener('click', function (e) {
     if (e.target === overlay) closeModal();
   });
   document.addEventListener('keydown', function (e) {
     if (e.key === 'Escape') closeModal();
   });
 })();

/* =================================================================
   SIZE GUIDE — For Html Table
   ================================================================= */
document.addEventListener('DOMContentLoaded', () => {
  initSizeGuideModals();
});

function initSizeGuideModals() {
  document.querySelectorAll('.size-guide-trigger').forEach(trigger => {
    const modalId = trigger.getAttribute('aria-controls');
    const modal   = document.getElementById(modalId);
    if (!modal) return;

    const closeBtn = modal.querySelector('.sg-modal__close');

    trigger.addEventListener('click', () => openModal(modal));
    closeBtn.addEventListener('click', () => closeModal(modal));

    modal.addEventListener('click', e => {
      if (e.target === modal) closeModal(modal);
    });

    modal.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeModal(modal);
    });
  });
}

function openModal(modal) {
  modal.removeAttribute('hidden');
  modal.classList.add('is-opening');
  modal.removeEventListener('animationend', onOpenEnd);
  modal.addEventListener('animationend', onOpenEnd, { once: true });
  document.body.style.overflow = 'hidden';
  modal.focus();
}

function closeModal(modal) {
  modal.classList.remove('is-opening');
  modal.classList.add('is-closing');
  modal.addEventListener('animationend', () => {
    modal.setAttribute('hidden', '');
    modal.classList.remove('is-closing');
    document.body.style.overflow = '';
  }, { once: true });
}

function onOpenEnd(e) {
  e.target.classList.remove('is-opening');
}

/* =================================================================
 SIZE GUIDE — CM/INCH Toggle
 ================================================================= */

let currentUnit = 'cm';

function setUnit(unit) {
  if (unit === currentUnit) return;
  currentUnit = unit;

  // Update toggle button states
  document.getElementById('btn-cm').classList.toggle('active', unit === 'cm');
  document.getElementById('btn-in').classList.toggle('active', unit === 'in');
  document.getElementById('btn-cm').setAttribute('aria-pressed', unit === 'cm');
  document.getElementById('btn-in').setAttribute('aria-pressed', unit === 'in');

  // Swap all measurement cells
  document.querySelectorAll('td[data-cm]').forEach(function(td) {
    td.textContent = td.getAttribute('data-' + unit);
  });
}

// Init to cm
setUnit('cm');